/**
 * Landing page content for Organization / Creator / Project apply flows.
 */
export const APPLICATION_LANDINGS = {
  organization: {
    type: "organization",
    path: "/organizations",
    applyPath: "/organizations/apply",
    eyebrow: "Pentecost+",
    title: "Become an Organization",
    lede:
      "Give your church, ministry, diocese, apostolate, school, or nonprofit a home on Pentecost+ — communities, livestreaming, media, fundraising, and more.",
    overviewTitle: "Built for faith-led organizations",
    overview:
      "Organizations are first-class identities on Pentecost+. Launch communities, host livestreams and events, grow a media library, run fundraising, and connect analytics and shop capabilities under one brand.",
    examplesTitle: "Who applies",
    examples: [
      "Churches",
      "Ministries",
      "Dioceses",
      "Apostolates",
      "Schools",
      "Nonprofits",
    ],
    benefitsTitle: "What you unlock",
    benefits: [
      {
        title: "Community & presence",
        body: "Public profile, community spaces, and brand presence that match your mission.",
      },
      {
        title: "Livestreams & events",
        body: "Broadcast services and gatherings with scheduling tools built for ministry ops.",
      },
      {
        title: "Media & fundraising",
        body: "Libraries, campaigns, donations, and analytics in one platform identity.",
      },
    ],
    requirementsTitle: "Requirements",
    requirements: [
      "Provide accurate contact and organization details.",
      "Accept the User Agreement, Terms & Conditions, Privacy Policy, and Community Guidelines.",
      "Understand that submission does not guarantee approval.",
    ],
    cta: "Apply as an Organization",
    entityLabel: "Organization name",
  },
  creator: {
    type: "creator",
    path: "/creators",
    applyPath: "/creators/apply",
    eyebrow: "Pentecost+",
    title: "Become a Creator",
    lede:
      "Filmmakers, musicians, podcasters, teachers, authors, and speakers — build your audience and publish with purpose on Pentecost+.",
    overviewTitle: "Creator tools for mission-driven voices",
    overview:
      "Creators are platform identities alongside Organizations. Share your story, grow an audience, publish content, and collaborate on projects without losing creative ownership.",
    examplesTitle: "Who applies",
    examples: [
      "Filmmakers",
      "Musicians",
      "Podcasters",
      "Teachers",
      "Authors",
      "Speakers",
    ],
    benefitsTitle: "What you unlock",
    benefits: [
      {
        title: "Creator identity",
        body: "A dedicated public profile and studio workspace for your work.",
      },
      {
        title: "Audience building",
        body: "Reach people who care about faith-centered storytelling and teaching.",
      },
      {
        title: "Collaboration",
        body: "Partner with organizations and projects across the Pentecost+ network.",
      },
    ],
    requirementsTitle: "Requirements",
    requirements: [
      "Provide accurate contact and creator details.",
      "Accept the User Agreement, Terms & Conditions, Privacy Policy, and Community Guidelines.",
      "Understand that submission does not guarantee approval.",
    ],
    cta: "Apply as a Creator",
    entityLabel: "Creator / display name",
  },
  project: {
    type: "project",
    path: "/projects",
    applyPath: "/projects/apply",
    eyebrow: "Pentecost+",
    title: "Start a Project",
    lede:
      "Documentary series, educational initiatives, outreach, collaborative productions, and ministry projects — bring people and partners together.",
    overviewTitle: "Projects that connect organizations and creators",
    overview:
      "Projects are collaborative initiatives. They can involve multiple organizations and creators, track milestones and funding, and share updates with supporters.",
    examplesTitle: "Who applies",
    examples: [
      "Documentary Series",
      "Educational Initiatives",
      "Community Outreach",
      "Collaborative Productions",
      "Ministry Projects",
    ],
    benefitsTitle: "What you unlock",
    benefits: [
      {
        title: "Shared mission space",
        body: "A public project home for story, goals, and progress.",
      },
      {
        title: "Milestones & funding",
        body: "Track work, fundraising goals, and supporter updates in one place.",
      },
      {
        title: "Cross-entity collaboration",
        body: "Connect organizations and creators around a single initiative.",
      },
    ],
    requirementsTitle: "Requirements",
    requirements: [
      "Provide accurate contact and project details.",
      "Accept the User Agreement, Terms & Conditions, Privacy Policy, and Community Guidelines.",
      "Understand that submission does not guarantee approval.",
    ],
    cta: "Apply to Start a Project",
    entityLabel: "Project name",
  },
};

export function getLandingConfig(type) {
  return APPLICATION_LANDINGS[type] || APPLICATION_LANDINGS.organization;
}
